import { render, staticRenderFns } from "./NewArticles.vue?vue&type=template&id=edbf2b48&scoped=true"
import script from "./NewArticles.vue?vue&type=script&lang=js"
export * from "./NewArticles.vue?vue&type=script&lang=js"
import style0 from "./NewArticles.vue?vue&type=style&index=0&id=edbf2b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbf2b48",
  null
  
)

export default component.exports